import { TranslationKey } from './../../../../../types/translation/TranslationKey';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { v4 } from 'uuid';
import { t } from '../../../../../types/translation/Translator';
import { Button } from '../../../../components/Button';
import { ButtonVariant } from '../../../../components/Button/Button';
import { OnboardingStep, OnboardingSubtitle, OnboardingTitle } from '../../components';
import OnboardingPaneHeader from '../../components/OnboardingPaneHeader';
import { OnboardingData, OnboardingRoutes } from '../..';
import StockLocationForm from './components/StockLocationForm';
import { StockLocationInput } from '../../../../../types/stock_location/stockLocation.input';

interface OnboardingStockLocationAddPaneProps {
  companyId: string;
  data: OnboardingData;
  setData: (data: OnboardingData) => void;
}

export default function OnboardingStockLocationAddPane({
  companyId,
  data,
  setData,
}: OnboardingStockLocationAddPaneProps) {
  const navigate = useNavigate();

  const [stockLocation, setStockLocation] = useState(new StockLocationInput({ companyId, id: v4() }));

  return (
    <div className='grid gap-4'>
      <OnboardingPaneHeader back={() => navigate(-1)} />

      <div className='grid gap-1'>
        <OnboardingStep />
        <OnboardingTitle text={'Add stock location manually'} />
        <OnboardingSubtitle
          text={
            'Define where your inventory is stored by adding stock locations. This helps you track and manage items efficiently across different sites.'
          }
        />
      </div>
      <StockLocationForm
        existing={data.summary.stockLocations}
        stockLocation={stockLocation}
        setStockLocation={setStockLocation}
      />
      <div className='flex gap-2'>
        <Button
          text={t(TranslationKey.add).singular.label}
          disabled={(() => {
            if (!stockLocation.name) return true;
            const withExistingName = [...data.summary.stockLocations.values()].find(
              sl => sl.name === stockLocation.name && sl.id !== stockLocation.id,
            );
            if (withExistingName) return true;
            return false;
          })()}
          onClick={() => {
            data.manual.stockLocations.set(stockLocation.id, stockLocation);
            setData(data);
            navigate(OnboardingRoutes.stockLocationOverview);
          }}
        />
        <Button
          text={t(TranslationKey.cancel).singular.label}
          onClick={() => navigate(-1)}
          variant={ButtonVariant.linkPrimary}
        />
      </div>
    </div>
  );
}
